import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Pricing.css';

const Pricing = () => {
  const navigate = useNavigate();

  // Bed pricing data
  const bedPricing = [
    { sharing: 'Single Sharing', roomType: 'AC', amount: 15000 },
    { sharing: 'Single Sharing', roomType: 'Non-AC', amount: 12000 },
    { sharing: 'Double Sharing', roomType: 'AC', amount: 13000 },
    { sharing: 'Double Sharing', roomType: 'Non-AC', amount: 10000 },
    { sharing: 'Triple Sharing', roomType: 'AC', amount: 11000 },
    { sharing: 'Triple Sharing', roomType: 'Non-AC', amount: 8000 },
    { sharing: 'Four Sharing', roomType: 'AC', amount: 10000 },
    { sharing: 'Four Sharing', roomType: 'Non-AC', amount: 7000 }
  ];

  return (
    <div className="pricing-page">
      <div className="page-header">
        <div className="header-container">
          <h1>Accommodation Pricing</h1>
          <p>Transparent pricing for comfortable living</p>
        </div>
      </div>

      <div className="pricing-container">
        {/* Bed Pricing Section */}
        <div className="pricing-section bed-pricing-section">
          <h2 className="section-title">Monthly Rent Structure</h2>
          <p className="section-description">Choose from our range of accommodation options</p>
          <div className="bed-pricing-table-wrapper">
            <table className="bed-pricing-table">
              <thead>
                <tr>
                  <th>Number of Sharing</th>
                  <th>Room Type</th>
                  <th>Monthly Rent</th>
                </tr>
              </thead>
              <tbody>
                {bedPricing.map((pricing, index) => (
                  <tr key={index}>
                    <td>{pricing.sharing}</td>
                    <td>
                      <span className={`room-type-badge ${pricing.roomType === 'AC' ? 'ac' : 'non-ac'}`}>
                        {pricing.roomType}
                      </span>
                    </td>
                    <td className="amount-cell">₹{pricing.amount.toLocaleString()} per month</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="pricing-note">
            <p><strong>Note:</strong> Above prices are indicative and can be customized based on location, amenities, and facilities provided. Contact us for a personalized quote.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
